import { api } from "@/lib/api/client";

export interface TeachingDirectoryTerm {
  id: string;
  name: string;
  status: "upcoming" | "active" | "closed";
  start_date: string | null;
  end_date: string | null;
}

export interface TeachingDirectoryCourse {
  course_id: string;
  code: string;
  title: string;
  title_ar: string | null;
  crn: string | null;
  status: "draft" | "published" | "archived";
  teaching_role: "primary" | "co_instructor";
  lead_name: string | null;
  href: string;
  term: TeachingDirectoryTerm | null;
}

export interface TeachingCourseDirectory {
  projection_version: "teaching-courses-v1";
  generated_at: string;
  shell_base: "/instructor" | "/admin/teaching";
  courses: TeachingDirectoryCourse[];
}

export const teachingCoursesApi = {
  list: () => api.get<TeachingCourseDirectory>("/workspaces/teaching/courses"),
};
